
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 59.13 17.91"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('text',{attrs:{"transform":"translate(19.98 14.16)","font-family":"Barlow-Bold,Barlow","font-size":"16.66","font-weight":"700"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('OR')])]),_c('path',{attrs:{"d":"M10.67 9.25c2.52-.05 5.03-.06 7.55-.08v.79c-2.52-.01-5.03-.03-7.55-.07l-5.34-.12C3.55 9.7 1.77 9.66 0 9.56c1.78-.09 3.56-.13 5.33-.21l5.34-.11zm48.46.32c-1.76.1-3.51.14-5.27.2l-5.27.12c-2.48.05-4.95.06-7.43.07v-.78c2.48.01 4.95.02 7.43.07l5.27.12c1.76.07 3.51.11 5.27.2z"}})])])
          )
        }
      }
    